const HUBSPOT_CONSENT_BANNER_SELECTOR = '#hs-eu-cookie-confirmation';

export const installThirdPartyFocusScrollGuard = () => {
  if (typeof window === 'undefined' || typeof HTMLElement === 'undefined') {
    return () => {};
  }

  const originalFocus = HTMLElement.prototype.focus;

  const guardedFocus = function guardedFocus(options) {
    const isHubSpotConsentBanner =
      this.matches?.(HUBSPOT_CONSENT_BANNER_SELECTOR) ||
      this.closest?.(HUBSPOT_CONSENT_BANNER_SELECTOR);

    if (!isHubSpotConsentBanner || window.location.hash) {
      return originalFocus.call(this, options);
    }

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const focusOptions = options && typeof options === 'object'
      ? { ...options, preventScroll: true }
      : { preventScroll: true };

    const result = originalFocus.call(this, focusOptions);

    // Older mobile browsers may ignore preventScroll. Restore the exact
    // pre-focus position on the next frame without removing keyboard focus.
    window.requestAnimationFrame(() => {
      if (window.scrollX !== scrollX || window.scrollY !== scrollY) {
        window.scrollTo(scrollX, scrollY);
      }
    });

    return result;
  };

  HTMLElement.prototype.focus = guardedFocus;

  return () => {
    if (HTMLElement.prototype.focus === guardedFocus) {
      HTMLElement.prototype.focus = originalFocus;
    }
  };
};

